import React, { useState } from 'react';
import Modal from 'components/shared/Modal/Modal';
import WarningBox from 'components/shared/WarningBox/WarningBox';
import ConfigParamsSettingsTable from '../ConfigParamSettingsTable/ConfigParamSettingsTable';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { TWO_HOP_ALIGNMENT_SCREEN_INDEXES } from '../utils';

import './TwoHopAdvancedSettings.css';

const WARNING_MESSAGES = [
  'WARNING: These changes only apply during Two-Hop Alignment.',
  'If Pivot 1 is configured with an SU WB, the Gain settings for that SU WB are set to minimum and cannot be modified.'
];

const TwoHopAdvancedSettings = (props) => {
  const [activeTableIndex, setActiveTableIndex] = useState(0);

  const { advancedSettingsData, onSave } = props;
  return (
    <Modal
      animateX={false}
      className={'paramAdvancedSettingModal'}
      close={props.onClose}
      height={'fit-content'}
      width={867}
      displayFlex={true}
      overflow={true}
    >
      <div className="TwoHopAdvancedSettingsContainer">
        <div className="TwoHopAdvancedSettingsHeaderContainer">
          <div
            className="TwoHopAdvancedSettingsHeaderContainer_BackArrow"
            onClick={() => props.backOnClick(TWO_HOP_ALIGNMENT_SCREEN_INDEXES.SETTINGS)}
          >
            <SvgAF img={IconLoader.left_arrow_default} hover={IconLoader.left_arrow_hover} />
          </div>
          <div className="TwoHopAdvancedSettingsHeaderContainer_HeaderText">Advanced Settings</div>
        </div>
        <div className="TwoHopAdvancedSettingsWarningContainer">
          <WarningBox warningMessages={WARNING_MESSAGES} />
        </div>
        <div className="TwoHopAdvancedSettingsTable_DeviceSelection">
          <Dropdown
            title={advancedSettingsData?.tables?.[activeTableIndex]?.title ?? 'loading'}
            data={advancedSettingsData ? advancedSettingsData.tables.map((table) => table.title) : []}
            selectItem={(item, id, index) => {
              setActiveTableIndex(index);
            }}
          />
        </div>
        <div className="TwoHopAdvancedSettingsTableParentContainer">
          <ConfigParamsSettingsTable
            requestStatus={Status.SUCCESS}
            data={advancedSettingsData.tables[activeTableIndex]}
            onApply={onSave}
            activeTableIndex={activeTableIndex}
          />
        </div>
      </div>
    </Modal>
  );
};

export default TwoHopAdvancedSettings;
